/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the difference between encoding a component and a full URI?`)
};

const es_ue_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre codificar un componente y una URI completa?`)
};

const de_ue_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen Komponenten-Kodierung und vollständiger URI-Kodierung?`)
};

const nl_ue_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen het coderen van een onderdeel en een volledige URI?`)
};

const fr_ue_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre l'encodage d'un composant et un URI complet ?`)
};

const it_ue_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra la codifica di un componente e un URI completo?`)
};

const pt_br2_ue_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre codificar um componente e uma URI completa?`)
};

const pt_ue_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre codificar um componente e um URI completo?`)
};

const ja_ue_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンポーネントのエンコードと完全なURIのエンコードの違いは何ですか?`)
};

const zh_ue_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编码组件和编码完整 URI 有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_faq1_q", locale)
	if (locale === "en") return en_ue_faq1_q(inputs)
	if (locale === "es") return es_ue_faq1_q(inputs)
	if (locale === "de") return de_ue_faq1_q(inputs)
	if (locale === "nl") return nl_ue_faq1_q(inputs)
	if (locale === "fr") return fr_ue_faq1_q(inputs)
	if (locale === "it") return it_ue_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_ue_faq1_q(inputs)
	if (locale === "pt") return pt_ue_faq1_q(inputs)
	if (locale === "ja") return ja_ue_faq1_q(inputs)
	return zh_ue_faq1_q(inputs)
};